import React, { useRef, useState, useEffect, useMemo } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import {
  ClearSeekFlag,
  LoadVideoUrl,
  SetControllerToggle,
  SetVideoControl,
  UpdateVideoTime,
} from "../redux/actions/controlAction";
import { connect, useSelector } from "react-redux";
import VideoPlayer from "../components/VideoPlayer";
import { Text, TextInput, TouchableOpacity } from "react-native";
import screenfull from "screenfull";
import { findDOMNode } from "react-dom";
import { AiOutlineFullscreen } from "react-icons/ai";
import { IoMdVolumeOff, IoMdVolumeHigh } from "react-icons/io";
import {
  FaPause,
  FaPlay,
  FaArrowRight,
  FaStopwatch,
  FaBug,
  FaSearch,
  FaSyncAlt,
  FaTrashAlt,
  FaEdit,
  FaVideo,
  FaCheckCircle,
  FaExclamationCircle,
  FaCheck,
  FaPlus,
  FaTimes,
  FaArrowLeft,
  FaAngleDown,
  FaAngleUp,
} from "react-icons/fa";
import Duration from "../components/VideoPlayer(new)/DurationOld";
import {
  fetchMatchStringById,
  getReviewerFeedbackStrings,
  runTechQC,
  saveReviewerFeedback,
} from "../config/mainRequest";
import { useHistory, useParams } from "react-router-dom";
import { pushCompletedTechQCString } from "../config/mainRequest";
import Logo from "../assets/Logo";
import toast from "react-hot-toast";
import {
  CircularProgress,
  IconButton,
  Stack,
  Typography,
  Modal,
  Box,
  Button,
  Tooltip,
} from "@mui/material";
import { ArrowBack, InfoOutlined } from "@mui/icons-material";
import { v4 as uuidv4 } from "uuid";
import { FlatList, View } from "react-native-web";
import { useQuery } from "react-query";
import { AutoSizer, CellMeasurer, List } from "react-virtualized";
import { CellMeasurerCache } from "react-virtualized";
import DurationOld from "../components/VideoPlayer(new)/DurationOld";
import { EVENT_MAP } from "../constant/positionList";
import { useAbly } from "ably/react";

// Confirmation Modal Component
const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  type = "default",
}) => {
  const getColors = () => {
    switch (type) {
      case "delete":
        return { bg: "#DA1414", hover: "#B91010" };
      case "update":
        return { bg: "#FF5A1F", hover: "#E54D18" };
      default:
        return { bg: "#007D48", hover: "#006838" };
    }
  };

  const colors = getColors();

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-modal"
      aria-describedby="confirmation-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 450,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Stack spacing={3}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" component="h2" fontWeight={600}>
              {title}
            </Typography>
            <IconButton onClick={onClose} size="small">
              <FaTimes />
            </IconButton>
          </Stack>

          <Typography color="black">{message}</Typography>

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              onClick={onClose}
              variant="outlined"
              sx={{
                textTransform: "none",
                borderColor: "#E5E7EB",
                color: "#666",
                "&:hover": {
                  borderColor: "#D1D5DB",
                  bgcolor: "#F9FAFB",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              variant="contained"
              sx={{
                textTransform: "none",
                bgcolor: colors.bg,
                "&:hover": {
                  bgcolor: colors.hover,
                },
              }}
            >
              Confirm
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};
const increaseTimestampByOneSecond = (timeString) => {
  if (!timeString) return timeString;

  const [hh, mm, ss] = timeString.split(":").map(Number);
  let totalSeconds = hh * 3600 + mm * 60 + ss + 1; // +1 second

  const newHH = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const newMM = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const newSS = String(totalSeconds % 60).padStart(2, "0");

  return `${newHH}:${newMM}:${newSS}`;
};

const TechQCMS = (props) => {
  const { UpdateVideoTime, SetVideoControl, videoUrl, all_matches } = props;
  const { matchId } = useParams();
  const matchDetails = props.all_matches.find(
    (match) => String(match.id) === String(matchId)
  );
  const { analystId, token } = useSelector((state) => ({
    analystId: state.auth.analyst_id,
    token: state.auth.token,
  }));

  const ably = useAbly();
  const [playing, setPlaying] = useState(false);
  const [ready, setReady] = useState(false);
  const [layoutWidth, setLayoutWidth] = useState(window.innerWidth);
  const [speed, setSpeed] = useState(1);
  const [duration, setDuration] = useState(null);
  const [seeking, setSeeking] = useState(false);
  const [jumpTo, setJumpTo] = useState("");
  const [showControls, setShowControl] = useState(false);
  const [isMute, setIsMute] = useState(false);
  const [activeFilter, setActiveFilter] = useState("all");
  const playerRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [initialEventDetails, setInitialEventDetails] = useState({});
  const [hasInitialized, setHasInitialized] = useState(false);
  const history = useHistory();
  const [isRunningQC, setIsRunningQC] = useState(false);
  const [IsInitialQC, setIsInitialQC] = useState(false);
  const reviewerId = matchDetails?.reviewer_details[0]?.id;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchStringValue, setSearchStringValue] = useState("");
  const [currentErrorGlobalIndex, setCurrentErrorGlobalIndex] = useState(-1);
  const [skipScrollToIndex, setSkipScrollToIndex] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  // Modal states
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    id: null,
    value: "",
  });
  const [updateModal, setUpdateModal] = useState({
    open: false,
    id: null,
    oldValue: "",
    newValue: {},
  });

  const { data: reviewStrings, refetch: refetchReviewerStrings } = useQuery({
    queryKey: ["getReviewerStrings"],
    queryFn: () =>
      getReviewerFeedbackStrings({
        matchId,
        token,
        reviewerId: reviewerId ?? analystId,
        analystId,
      }),
  });

  // Process review strings to create a map of string -> review data
  const reviewStringMap = React.useMemo(() => {
    if (!reviewStrings?.string_details) return new Map();

    const map = new Map();
    Object.entries(reviewStrings.string_details).forEach(([key, value]) => {
      map.set(key.trim(), value);
    });
    return map;
  }, [reviewStrings]);

  const handleLogout = () => {
    console.log("Logout clicked");
    // Logout logic here
  };

  const isYoutubeUrl = () => {
    if (videoUrl || matchDetails?.youtube_videos[0]?.url) {
      const hostname = new URL(videoUrl || matchDetails?.youtube_videos[0]?.url)
        .hostname;
      return hostname.includes("youtube.com");
    }
    return false;
  };

  const handleSeekMouseDown = (e) => {
    setSeeking(true);
  };

  const handleSeekChange = (e) => {
    UpdateVideoTime(parseFloat(e.target.value));
  };

  const handleSeekMouseUp = (e) => {
    setSeeking(false);
    playerRef.current.seekTo(parseFloat(e.target.value));
  };

  const full = () => {
    if (screenfull.isEnabled) {
      screenfull.request(findDOMNode(playerRef.current));
    }
  };

  const handleMute = () => {
    setIsMute(!isMute);
  };

  const jumpManually = (str) => {
    const jumpInputList = str?.split(":");
    if (jumpInputList.length < 3) {
      return;
    }
    const totalSecends =
      parseInt(jumpInputList[0]) * 60 * 60 +
      parseInt(jumpInputList[1]) * 60 +
      parseInt(jumpInputList[2]);
    playerRef.current.seekTo(parseFloat(totalSecends));
    setPlaying(true);
    setJumpTo("");
  };

  const [matchString, setMatchString] = useState([]);
  const [fetchedQcData, setFetcheddQcData] = useState();
  const [transformedStrings, setTransformedStrings] = useState();
  const listRef = useRef(null);
  const [currentErrorIndex, setCurrentErrorIndex] = useState(0);
  const [searchMatchIndexes, setSearchMatchIndexes] = useState([]);
  const [currentSearchIndex, setCurrentSearchIndex] = useState(-1);
  const transformMatchStrings = (qcData) => {
    if (!qcData) return [];

    return qcData.reduce((acc, item) => {
      if (!Array.isArray(item.examples)) return acc;

      const { error_type, message, examples } = item;

      const transformed = examples.map((example) => ({
        id: uuidv4(),
        value: example,
        type: error_type.toLowerCase(),
        message,
        ignored: false,
      }));

      return acc.concat(transformed);
    }, []);
  };

  useEffect(() => {
    const getMatchString = async () => {
      try {
        setIsLoading(true);
        const result = await fetchMatchStringById(matchId, analystId, token);
        setMatchString(
          result?.temp_string?.split(",").map((str) => str.trim())
        );
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Failed to fetch match string", error);
      }
    };

    if (matchId && analystId && token) {
      getMatchString();
    }
  }, [matchId, analystId, token]);

  useEffect(() => {
    if (matchString?.length === 0) return;
    const stringArray = matchString
      .map((item) => (typeof item === "string" ? item : item?.value))
      .filter(Boolean);

    const runTechQCString = async () => {
      try {
        setIsInitialQC(true);
        const qcResult = await runTechQC(stringArray, token, matchId);
        setFetcheddQcData(qcResult?.qc_results);
        setIsInitialQC(false);
      } catch (error) {
        setIsInitialQC(false);
        console.error("Failed to fetch match string", error);
      }
    };

    if (matchString && token) {
      runTechQCString();
    }
  }, [matchId, matchString, token]);

// helper moved outside effect so it can be reused by handlers
const mergeMatchStringsWithErrors = (
  baseStrings,
  qcData,
  existingTransformed = null
) => {
  const errors = transformMatchStrings(qcData);

  const errorMap = new Map();
  const parseErrorValue = (value) => {
    const strings = [];

    let cleanValue = value;
    if (value.includes(":")) {
      const colonIndex = value.indexOf(":");
      if (colonIndex < 50 && value[colonIndex + 1] === " ") {
        cleanValue = value.substring(colonIndex + 1).trim();
      }
    }

    // arrow notation
    if (cleanValue.includes("->")) {
      const parts = cleanValue.split("->").map((p) => p.trim());
      strings.push(...parts.filter(Boolean));
    } else if (cleanValue.includes(",")) {
      //  csv values
      const parts = cleanValue.split(",").map((p) => p.trim());
      strings.push(...parts.filter(Boolean));
    } else {
      // Single value
      strings.push(cleanValue.trim());
    }

    return strings.filter(Boolean);
  };

  errors.forEach((item) => {
    if (item.value) {
      const parts = parseErrorValue(item.value);

      parts.forEach((part) => {
        const existing = errorMap.get(part.trim());

        if (existing) {
          existing.push(item);
        } else {
          errorMap.set(part.trim(), [item]);
        }
      });
    }
  });

  const normalize = (v) => (typeof v === "string" ? v.trim() : v?.value?.trim());

  // If we have existing transformedStrings (manual additions), store them
  if (existingTransformed && existingTransformed?.length > 0) {
    return existingTransformed.map((str) => {
      const value = normalize(str);
      const errorArray = errorMap.get(value);
      const reviewData = reviewStringMap.get(value);

      // Determine type and message based on QC
      let finalType = "noIssue";
      let finalMessage = null;

      if (errorArray) {
        finalType = errorArray.some((err) => err.type === "warning")
          ? "warning"
          : "error";
        finalMessage = errorArray.map((err) => err.message).join(" | ");
      }

      // Review errors override QC result
      if (reviewData?.string_status === 0) {
        finalType = "review_error";
        finalMessage = reviewData?.comments || "Pending review feedback";
      }

      const isIgnored =
        str?.ignored === true || reviewData?.string_status === 3;
      if (isIgnored) {
        finalType = "ignored";
        finalMessage = str.message || reviewData?.comments || finalMessage;
      }

      return {
        ...str,
        id: uuidv4(),
        issues: errorArray || [],
        type: finalType,
        message: finalMessage,
        ignored: isIgnored,
        reviewStatus: reviewData?.string_status,
        reviewComments: reviewData?.comments,
      };
    });
  }

  // Initial load or no existing transformed strings - use baseStrings
  return baseStrings.map((str) => {
    const value = str?.trim();
    const errorArray = errorMap.get(value);
    const reviewData = reviewStringMap.get(value);

    // Determine type based on errors and review status
    let finalType = "noIssue";
    let finalMessage = null;

    if (errorArray) {
      finalType = errorArray.some((err) => err.type === "warning")
        ? "warning"
        : "error";
      finalMessage = errorArray.map((err) => err.message).join(" | ");
    }

    // If review status is 0 (Pending), mark as review_error
    if (reviewData?.string_status === 0) {
      finalType = "review_error";
      finalMessage = reviewData?.comments || "Pending review feedback";
    }

    // id status is 3 then mark it as ignore if status is 2 from reviewer side and comment is present consider it as ignored as for error status is 1
    const isIgnored =
      (reviewData?.string_status === 3 ||
        reviewData?.string_status === 2) &&
      errorArray?.length > 0;

    // Override type to "ignored" if status is 3 and there are warnings/errors
    if (isIgnored) {
      finalType = "ignored";
    }

    return {
      value: value,
      id: uuidv4(),
      issues: errorArray || [],
      type: finalType,
      message: finalMessage,
      ignored: isIgnored,
      reviewStatus: reviewData?.string_status,
      reviewComments: reviewData?.comments,
    };
  });
};

useEffect(() => {
  if (matchString?.length > 0 && fetchedQcData?.length >= 0) {
    setTransformedStrings((transformedStrings) => {
      const base =
        transformedStrings?.length > 0
          ? transformedStrings.map((s) => s.value)
          : matchString;

      const merged = mergeMatchStringsWithErrors(
        base,
        fetchedQcData,
        transformedStrings
      );
      return merged;
    });
  }
}, [matchString, fetchedQcData, reviewStringMap]);

  const updateTag = async (id, newValue) => {
    const oldItem = transformedStrings?.find((s) => s.id === id);

    if (!oldItem) {
      console.warn("Item not found for update");
      return;
    }

    if (newValue.type === "fixed") {
      const updatedArray = transformedStrings.map((item) =>
        item.id === id ? { ...item, ...newValue } : item
      );
      setTransformedStrings(updatedArray);
      return;
    }

    if (oldItem.type === "warning") {
      const updatedArray = transformedStrings.map((item) =>
        item.id === id ? { ...item, ...newValue } : item
      );

      setTransformedStrings(updatedArray);

      return;
    }
    // modal open
    setUpdateModal({
      open: true,
      id,
      oldValue: oldItem.value,
      newValue: { ...oldItem, ...newValue },
    });
  };

  const confirmUpdate = async () => {
    const { id, oldValue, newValue } = updateModal;
    const oldItem = transformedStrings?.find((s) => s.id === id);

    if (
      oldItem.type === "error" ||
      oldItem.type === "warning" ||
      oldItem.type === "review_error"
    ) {
      newValue.type = "fixed";
      newValue.message = "Issue resolved";
    }

    const updatedArray = transformedStrings.map((item) =>
      item.id === id ? { ...item, ...newValue, id: item.id } : item
    );

    // UPDATE STATE
    setTransformedStrings(updatedArray);

    setTimeout(() => {
      const index = updatedArray.findIndex((s) => s.id === id);
      for (let i = index; i <= updatedArray.length - 1; i++) {
        cache.current.clear(i, 0);
      }

      if (listRef.current) {
        listRef.current.scrollToPosition(scrollPosition);
        // listRef.current.recomputeRowHeights(index);
      }
    }, 0);

    // API update
    const stringArray = updatedArray
      .map((item) => item.value?.trim())
      .filter((v) => v && v.length > 0)
      .join(",");

    await pushCompletedTechQCString(matchId, analystId, token, stringArray, 1);

    ably.channels.get(`match-${matchId}`).publish("match-string-updated", {
      matchId,
      updatedAt: Date.now(),
    });

    // REVIEW LOGIC
    if (oldItem.type === "review_error") {
      try {
        await saveReviewerFeedback({
          token,
          body: {
            match_id: Number(matchId),
            reviewer_id: reviewerId ?? analystId,
            string_details: [
              {
                string: oldItem.value,
                string_status: oldItem.reviewStatus,
                comments: oldItem.reviewComments,
                delete: true,
              },
              {
                string: newValue.value,
                string_status: 1,
                comments: oldItem.reviewComments,
              },
            ],
          },
        });

        toast.success("Feedback saved!");
      } catch (err) {
        console.error("Failed to save feedback:", err);
        toast.error("Failed to save feedback.");

        // rollback
        setTransformedStrings((prevStrings) =>
          prevStrings.map((item) => (item.id === id ? oldItem : item))
        );
      }
    }

    setUpdateModal({ open: false, id: null, oldValue: "", newValue: {} });
  };

  const addTag = (afterId) => {
    setCurrentErrorGlobalIndex(null);
    setSkipScrollToIndex(true);

    setTransformedStrings((prevStrings) => {
      const index = prevStrings.findIndex((item) => item.id === afterId);
      if (index === -1) return prevStrings;

      const newItem = {
        id: uuidv4(),
        value: " ",
        type: "noIssue",
        message: null,
        ignored: false,
      };

      setTimeout(() => {
        const startIndex = Math.max(0, index);
        for (let i = startIndex; i <= updated.length - 1; i++) {
          cache.current.clear(i, 0);
        }

        if (listRef.current) {
          listRef.current.scrollToPosition(scrollPosition);
          // listRef.current.recomputeRowHeights(index);
        }
      }, 0);

      const updated = [...prevStrings];
      updated.splice(index + 1, 0, newItem);
      return updated;
    });
  };

  useEffect(() => {
    if (skipScrollToIndex) {
      setSkipScrollToIndex(false);
    }
  }, [transformedStrings]);

  const runTechQCManually = async () => {
    const stringArray = transformedStrings
      .map((item) => (typeof item === "string" ? item : item?.value)?.trim())
      .filter((v) => v && v.length > 0);

    try {
      setIsRunningQC(true);
      const qcResult = await runTechQC(stringArray, token, matchId);
      setFetcheddQcData(qcResult.qc_results);
      setTransformedStrings((prev) => {
        const base = prev?.length > 0 ? prev.map((s) => s.value) : stringArray;
        return mergeMatchStringsWithErrors(base, qcResult.qc_results, prev);
      });

      if (listRef.current) {
        cache.current.clearAll();
        // listRef.current.recomputeRowHeights();
        listRef.current.scrollToPosition(scrollPosition);
      }

      toast.success("QC Completed Successfully");
      setIsRunningQC(false);
    } catch (error) {
      console.error("Failed to fetch match string", error);
      toast.error("Failed to Run QC");
      setIsRunningQC(false);
    }
  };

  const handleSubmitFinalQC = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    const stringArray = transformedStrings
      .map((item) => (typeof item === "string" ? item : item?.value)?.trim())
      .filter((v) => v && v.length > 0);

    try {
      const qcResult = await runTechQC(stringArray, token, matchId);
      const latestQC = qcResult?.qc_results || [];
      // update state and merge errors so new strings reflect status
      setFetcheddQcData(qcResult?.qc_results);
      setTransformedStrings((prev) => {
        const base = prev?.length > 0 ? prev.map((s) => s.value) : stringArray;
        return mergeMatchStringsWithErrors(base, qcResult?.qc_results, prev);
      });
      cache.current.clearAll();
      if (listRef.current) {
        listRef.current.scrollToPosition(scrollPosition);
        // listRef.current.recomputeRowHeights(index);
      }
      const qcIssues = latestQC.flatMap((item) =>
        item.examples.map((ex) => ({
          str: ex,
          type: item.error_type.toLowerCase(),
        }))
      );

      let actualErrors = 0;
      let actualWarnings = 0;

      stringArray.forEach((str) => {
        const issuesForStr = qcIssues.filter((i) => i.str === str);
        const hasError = issuesForStr.some((i) => i.type === "error");
        const hasWarning = issuesForStr.some((i) => i.type === "warning");
        const uiItem = transformedStrings.find((item) => item.value === str);
        const isIgnored =
          uiItem?.type === "ignored" || uiItem?.reviewStatus === 3;

        if (hasError && isIgnored) return;
        if (hasError && hasWarning) return;
        if (hasWarning && isIgnored) return;
        if (hasWarning) actualWarnings++;
        if (hasError) actualErrors++;
      });

      if (actualErrors > 0 || actualWarnings > 0) {
        setFetcheddQcData(latestQC);

        // cache.current.clearAll();
        if (listRef.current) {
          listRef.current.recomputeRowHeights();
        }

        toast.error("QC Failed! Fix all errors/warnings before submitting.");
        setIsSubmitting(false);
        return;
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to run QC before final submission.");
      setIsSubmitting(false);
      return;
    }

    const updatedArray = [...stringArray];
    let lastStr = updatedArray[updatedArray.length - 1];
    let parts = lastStr.split("-");

    if (parts[6]) {
      parts[6] = increaseTimestampByOneSecond(parts[6]);
      updatedArray[updatedArray.length - 1] = parts.join("-");
    }

    const finalMatchString = updatedArray.join(",");

    const result = await pushCompletedTechQCString(
      matchId,
      analystId,
      token,
      finalMatchString
    );

    if (result.success) {
      toast.success("Match String Saved Successfully");

      ably.channels.get(`match-${matchId}`).publish("match-string-updated", {
        matchId,
        updatedAt: Date.now(),
      });

      setTimeout(() => {
        history.push(`/videoplayer?match_id=${matchId}`, {
          TechQCSubmit: true,
        });
      }, 800);
    } else {
      toast.error("Failed to push match string");
    }

    setIsSubmitting(false);
  };

  const deleteStringByIndex = async (id) => {
    setCurrentErrorGlobalIndex(null);
    setSkipScrollToIndex(true);
    const item = transformedStrings?.find((s) => s.id === id);

    // Open modal instead of directly deleting
    setDeleteModal({
      open: true,
      id,
      value: item?.value || "",
    });
  };

  const confirmDelete = async () => {
    const { id } = deleteModal;

    const item = transformedStrings?.find((s) => s.id === id);
    const deleteIndex = transformedStrings.findIndex((s) => s.id === id);

    // Handle review error logic BEFORE updating the strings
    if (item?.type === "review_error") {
      await saveReviewerFeedback({
        token,
        body: {
          match_id: Number(matchId),
          reviewer_id: reviewerId ?? analystId,
          string_details: [
            {
              string: item.value,
              string_status: item.reviewStatus,
              comments: item.comments,
              delete: true,
            },
          ],
        },
      });
    }

    setTimeout(() => {
      if (deleteIndex !== -1) {
        const startIndex = Math.max(0, deleteIndex);

        for (let i = startIndex; i <= updatedArray.length - 1; i++) {
          cache.current.clear(i, 0);
        }

        if (listRef.current) {
          listRef.current.scrollToPosition(scrollPosition);
          // listRef.current.recomputeRowHeights(index);
        }
      }
    }, 0);
    const updatedArray = transformedStrings.filter((s) => s.id !== id);
    setTransformedStrings(updatedArray);

    const stringArray = updatedArray
      .map((item) => item.value?.trim())
      .filter((v) => v && v.length > 0)
      .join(",");

    await pushCompletedTechQCString(matchId, analystId, token, stringArray, 1);
    toast.success("String deleted successfully");
    ably.channels.get(`match-${matchId}`).publish("match-string-updated", {
      matchId,
      updatedAt: Date.now(),
    });
    setDeleteModal({ open: false, id: null, value: "" });
  };

  const warningCount = transformedStrings?.filter(
    (item) => item.type === "warning"
  ).length;

  const errorCount = transformedStrings?.filter(
    (item) => item.type === "error"
  ).length;

  const noErrorsCount = transformedStrings?.filter(
    (item) => item.type === "noIssue"
  ).length;

  const reviewErrorCount = transformedStrings?.filter(
    (item) => item.type === "review_error"
  ).length;

  useEffect(() => {
    if (
      warningCount >= 0 &&
      errorCount >= 0 &&
      reviewErrorCount >= 0 &&
      noErrorsCount >= 0 &&
      !hasInitialized
    ) {
      const details = {
        warning: warningCount,
        error: errorCount,
        reviewError: reviewErrorCount,
        noIssue: noErrorsCount,
        total: transformedStrings.length,
      };
      setInitialEventDetails(details);
      setHasInitialized(true);
    }
  }, [
    errorCount,
    reviewErrorCount,
    noErrorsCount,
    warningCount,
    hasInitialized,
    transformedStrings?.length,
  ]);

  const formatTimeFromSeconds = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const details = all_matches?.find((m) => {
    return m.id.toString() === matchId;
  });

  const cache = useRef(
    new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 180,
    })
  );

  // useEffect(() => {
  //   cache.current.clearAll();
  //   if (listRef.current) {
  //     listRef.current.recomputeRowHeights();
  //   }
  // }, [searchStringValue, activeFilter ,transformedStrings]);

  // useEffect(() => {
  //   if (listRef.current) {
  //     listRef.current.forceUpdateGrid();
  //   }
  // }, [searchStringValue, activeFilter, transformedStrings]);

  // const scrollToErrorIndex = (index, filteredData) => {
  //   if (!listRef.current) return;

  //   listRef.current.scrollToRow(index);
  // };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!playerRef.current) return;

      switch (e.key) {
        case " ":
          e.preventDefault();
          props.SetVideoControl(!props.videoControl);
          break;

        case "ArrowRight":
          playerRef.current.seekTo(props.videoTime + 5);
          break;

        case "ArrowLeft":
          playerRef.current.seekTo(props.videoTime - 5);
          break;

        case "m":
        case "M":
          setIsMute((prev) => !prev);
          break;

        // case "f":
        // case "F":
        //   if (screenfull.isEnabled) {
        //     screenfull.toggle(findDOMNode(playerRef.current));
        //   }
        //   break;

        case "P":
          goToPrevError();
          break;

        case "N":
          goToNextError();
          break;

        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [props.videoControl, props.videoTime, playerRef]);

  useEffect(() => {
    cache.current.clearAll();

    if (listRef.current) {
      listRef.current.recomputeRowHeights();
    }
  }, [activeFilter]);

  const visibleErrorGlobalIndexes = useMemo(() => {
    if (!transformedStrings || transformedStrings.length === 0) return [];

    const search = (searchStringValue || "").trim().toLowerCase();

    return transformedStrings.reduce((acc, item, idx) => {
      // Must be error, warning or review_error
      const isErrorType =
        item.type === "error" ||
        item.type === "warning" ||
        item.type === "review_error";

      if (!isErrorType) return acc;

      // Apply filter
      if (activeFilter !== "all" && item.type !== activeFilter) return acc;

      // No search → include directly
      if (!search) {
        acc.push(idx);
        return acc;
      }

      // Basic search on value (NO splitting!)
      if (item.value.toLowerCase().includes(search)) {
        acc.push(idx);
      }

      return acc;
    }, []);
  }, [transformedStrings, activeFilter, searchStringValue]);

  // const errorIndexes = useMemo(() => {
  //   if (!transformedStrings) return [];

  //   return transformedStrings.reduce((acc, item, idx) => {
  //     if (item.type === "error" || item.type === "warning" || item.type === "review_error") {
  //       acc.push(idx);
  //     }
  //     return acc;
  //   }, []);
  // }, [transformedStrings]);

  const goToNextError = () => {
    if (activeFilter !== "all") return;

    const list = visibleErrorGlobalIndexes;
    if (!list || list.length === 0) {
      toast.error("No errors/warnings available");
      return;
    }

    // if (currentErrorGlobalIndex === -1) {
    //   const first = list[0];
    //   setCurrentErrorGlobalIndex(first);
    //   // eslint-disable-next-line no-unused-expressions
    //   // listRef.current?.scrollToRow(first);
    //   return;
    // }

    const currentIndexPos = list.indexOf(currentErrorGlobalIndex);
    const nextPos = (currentIndexPos + 1) % list.length;
    const nextGlobalIndex = list[nextPos];

    setCurrentErrorGlobalIndex(nextGlobalIndex);
    // eslint-disable-next-line no-unused-expressions
    // listRef.current?.scrollToRow(nextGlobalIndex);
  };

  const goToPrevError = () => {
    if (activeFilter !== "all") return;

    const list = visibleErrorGlobalIndexes;
    if (!list || list.length === 0) {
      toast.error("No errors/warnings available");
      return;
    }

    // if (currentErrorGlobalIndex === -1) {
    //   const last = list[list.length - 1];
    //   setCurrentErrorGlobalIndex(last);
    //   // eslint-disable-next-line no-unused-expressions
    //   // listRef.current?.scrollToRow(last);
    //   return;
    // }

    const currentIndexPos = list.indexOf(currentErrorGlobalIndex);
    const prevPos = (currentIndexPos - 1 + list.length) % list.length;
    const prevGlobalIndex = list[prevPos];

    setCurrentErrorGlobalIndex(prevGlobalIndex);
    // eslint-disable-next-line no-unused-expressions
    // listRef.current?.scrollToRow(prevGlobalIndex);
  };

  // const filteredData = useMemo(() => {
  //   if (!transformedStrings) return [];

  //   const search = (searchStringValue || "").trim().toLowerCase();

  //   return transformedStrings.filter((item) => {
  //     if (activeFilter !== "all" && item.type !== activeFilter) {
  //       return false;
  //     }

  //     if (!search) {
  //       return true;
  //     }

  //     const parts = item.value?.split("-") || [];
  //     const timestamp = (parts[6] || "").toLowerCase();

  //     return (
  //       timestamp.includes(search) || item.value.toLowerCase().includes(search)
  //     );
  //   });
  // }, [transformedStrings, activeFilter, searchStringValue]);

  const filteredData = useMemo(() => {
    if (!transformedStrings) return [];

    return transformedStrings.filter((item) => {
      if (activeFilter !== "all" && item.type !== activeFilter) {
        return false;
      }
      return true;
    });
  }, [transformedStrings, activeFilter]);

  useEffect(() => {
    setCurrentSearchIndex(-1);
    setSearchMatchIndexes([]);
  }, [activeFilter]);

  useEffect(() => {
    if (!searchStringValue || !filteredData?.length) {
      setSearchMatchIndexes([]);
      setCurrentSearchIndex(-1);
      return;
    }

    const search = searchStringValue.toLowerCase();

    const matches = filteredData.reduce((acc, item, index) => {
      const parts = item.value?.split("-") || [];
      const timestamp = (parts[6] || "").toLowerCase();

      if (
        item.value.toLowerCase().includes(search) ||
        timestamp.includes(search)
      ) {
        acc.push(index); // ✅ index in filteredData
      }

      return acc;
    }, []);

    setSearchMatchIndexes(matches);
    setCurrentSearchIndex(matches.length ? matches[0] : -1);
  }, [searchStringValue, filteredData]);

  const goToNextSearchMatch = () => {
    if (!searchMatchIndexes.length) return;

    const currentPos = searchMatchIndexes.indexOf(currentSearchIndex);
    const nextPos = (currentPos + 1) % searchMatchIndexes.length;
    setCurrentSearchIndex(searchMatchIndexes[nextPos]);
  };

  const goToPrevSearchMatch = () => {
    if (!searchMatchIndexes.length) return;

    const currentPos = searchMatchIndexes.indexOf(currentSearchIndex);
    const prevPos =
      (currentPos - 1 + searchMatchIndexes.length) % searchMatchIndexes.length;

    setCurrentSearchIndex(searchMatchIndexes[prevPos]);
  };

  if (isLoading) {
    return (
      <Stack
        style={{
          width: "100%",
          height: "100%",
          zIndex: 10,
          backgroundColor: "#fff",
          position: "absolute",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Logo />
        <Typography style={{ color: "#131313", fontFamily: "Source Sans 3" }}>
          loading setup...
        </Typography>
      </Stack>
    );
  }

  return (
    <div>
      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        open={deleteModal.open}
        onClose={() => setDeleteModal({ open: false, id: null, value: "" })}
        onConfirm={confirmDelete}
        title="Delete String"
        message={
          <>
            Are you sure you want to delete this string?{" "}
            <strong>"{deleteModal.value}"</strong>
          </>
        }
        type="delete"
      />

      {/* Update Confirmation Modal */}
      <ConfirmationModal
        open={updateModal.open}
        onClose={() =>
          setUpdateModal({ open: false, id: null, oldValue: "", newValue: {} })
        }
        onConfirm={confirmUpdate}
        title="Update String"
        message={
          <>
            Are you sure you want to update this string from{" "}
            <strong>"{updateModal.oldValue}"</strong> to{" "}
            <strong>"{updateModal.newValue?.value}"</strong>?
          </>
        }
        type="update"
      />
      {/* Header */}
      <div style={styles.header.container}>
        <div style={styles.header.side}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
            size="small"
            sx={{ background: "#e1e1e1", mr: 1 }}
          >
            <ArrowBack fontSize="16px" />
          </IconButton>
        </div>
        <div style={styles.header.center}>
          <span style={styles.header.score}>{matchId}</span>
          <span style={styles.header.matchInfo}>
            {matchDetails?.team_a_details?.name} vs{" "}
            {matchDetails?.team_b_details?.name}
          </span>
        </div>
      </div>

      {/* Cards */}
      <div style={styles.cardContainer}>
        {/* Card 1 */}
        <div style={styles.card1.card}>
          <div style={styles.card1.content}>
            <div style={{ ...styles.card1.team, alignItems: "flex-start" }}>
              <div style={styles.card1.teamBoxA}>
                <div style={styles.card1.label}>Team A</div>
              </div>
              <div style={styles.card1.teamNameText}>
                {matchDetails?.team_a_details?.name}
              </div>
            </div>

            <div style={{ ...styles.card1.team, alignItems: "flex-end" }}>
              <div style={styles.card1.teamBoxB}>
                <div style={styles.card1.label}>Team B</div>
              </div>
              <div style={styles.card1.teamNameText}>
                {matchDetails?.team_b_details?.name}
              </div>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div style={styles.card2.card}>
          <div style={styles.card2.content}>
            <div style={styles.card2.box}>
              <div style={styles.card2.id}>
                {matchDetails?.analyst_details[0]?.id}
              </div>
            </div>

            <div style={styles.card2.textRight}>
              <div style={styles.card2.name}>
                {matchDetails?.analyst_details[0]?.name}
              </div>
              <div style={styles.card2.label}>Analyst ID & Name</div>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div style={styles.card3.card}>
          <div style={styles.card3.row}>
            <div style={styles.card3.title}>Elapsed time</div>

            <div style={styles.card3.timeProgressWrapper}>
              <div style={styles.card3.time}>
                {formatTimeFromSeconds(details.analysis_tat) || "00:00:00"}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.urlCard.wrapper}>
        <div style={styles.urlCard.row}>
          <div style={styles.urlCard.label}>Load Custom Video URL</div>
          <div style={styles.urlCard.inputGroup}>
            <input
              type="text"
              placeholder="Paste match video url.."
              style={styles.urlCard.input}
            />
            <button style={styles.urlCard.button}>
              <FaSearch color="#fff" size={12} />
            </button>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "5px",
          margin: "1rem",
        }}
      >
        <div
          style={{
            width: "60%",
          }}
        >
          <div
            style={{
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "1rem",
              }}
            >
              <Text
                style={{ fontSize: 18, fontWeight: "600", marginBottom: 12 }}
              >
                Event Clip Tracker
              </Text>
              <Text
                style={{ fontSize: 12, color: "#FF5A1F", marginBottom: 12 }}
              >
                Verify Event String with video clip..
              </Text>
            </div>
            <View style={styles.videoContainer}>
              {props.videoUrl || matchDetails?.youtube_videos[0]?.url ? (
                <VideoPlayer
                  cref={playerRef}
                  url={props.videoUrl || matchDetails?.youtube_videos[0]?.url}
                  controls={showControls}
                  played={props.videoTime}
                  muted={isMute}
                  onProgress={(e) => {
                    !seeking && UpdateVideoTime(e);
                  }}
                  //    setElapsedTime={this.setElapsedTime}
                  playing={props.videoControl}
                  onPause={() => {
                    SetVideoControl(false);
                  }}
                  onEnded={() => {
                    SetVideoControl(false);
                  }}
                  onPlay={() => {
                    SetVideoControl(true);
                  }}
                  onReady={() => {
                    setReady(true);
                  }}
                  playbackRate={speed}
                  onDuration={(t) => {
                    setDuration(t);
                  }}
                />
              ) : (
                <Stack
                  style={{
                    height: "60vh",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography style={{ fontSize: 16, color: "#FF5A1F" }}>
                    Video URL Not Found.
                  </Typography>
                </Stack>
              )}

              {ready && !isYoutubeUrl() && (
                <View style={styles.videoTimeline}>
                  <input
                    type="range"
                    value={props.videoTime} // in milliseconds
                    style={{ width: "100%", borderWidth: 0 }}
                    min={0}
                    max={duration * 1000} // convert seconds to milliseconds
                    step={10} // Optional: allow 10ms steps; change to 1 for full ms precision
                    onMouseDown={handleSeekMouseDown}
                    onChange={(e) => handleSeekChange(e.target.value)} // value is in ms
                    onMouseUp={(e) => handleSeekMouseUp(e.target.value)} // value is in ms
                  />
                  <TouchableOpacity
                    onPress={full}
                    style={{
                      width: 2 * (layoutWidth / 100),
                      height: 2 * (layoutWidth / 100),
                      borderRadius: 5,
                      justifyContent: "center",
                      alignItems: "center",
                      boxShadow: "0px 2px 6px #00000020",
                      backgroundColor: "#e1e1e1",
                      marginRight: 10,
                      marginLeft: 3,
                    }}
                  >
                    <AiOutlineFullscreen
                      color="#131313"
                      size={layoutWidth / 100}
                    />
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={handleMute}
                    style={{
                      width: 2 * (layoutWidth / 100),
                      height: 2 * (layoutWidth / 100),
                      borderRadius: 5,
                      justifyContent: "center",
                      alignItems: "center",
                      boxShadow: "0px 2px 6px #00000020",
                      backgroundColor: "#e1e1e1",
                      marginRight: 10,
                      marginLeft: 3,
                    }}
                  >
                    {isMute ? (
                      <IoMdVolumeOff color="#131313" size={layoutWidth / 100} />
                    ) : (
                      <IoMdVolumeHigh
                        color="#131313"
                        size={layoutWidth / 100}
                      />
                    )}
                  </TouchableOpacity>
                </View>
              )}

              {ready && (
                <View style={styles.controlContainer}>
                  <View style={styles.leftControl}>
                    <div>
                      {" "}
                      <FaStopwatch
                        size={"1rem"}
                        color="rgba(170, 173, 177, 1)"
                      />
                      {/* <CiStopwatch /> */}
                      <Text
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "rgba(9, 16, 29, 1)",
                          marginStart: "0.5rem",
                        }}
                      >
                        Jump To :
                      </Text>
                    </div>
                    <View
                      style={{ flexDirection: "row", alignItems: "center" }}
                    >
                      <TextInput
                        style={{
                          maxWidth: "5rem",
                          fontSize: "10px",
                          border: "0.715px solid rgba(144, 152, 161, 0.20) ",
                          borderRadius: "3px",
                          color: "rgba(33, 33, 46, 0.50)",
                          paddingVertical: "0.8rem",
                          outline: "none",
                          textAlign: "center",
                          marginStart: "0.8rem",
                        }}
                        onChangeText={setJumpTo}
                        defaultValue={jumpTo}
                        placeholder="HH:MM:SS"
                      />
                      <TouchableOpacity
                        disabled={jumpTo === ""}
                        onPress={() => jumpManually(jumpTo)}
                        style={{
                          width: "1.4rem",
                          height: "1.4rem",
                          marginStart: "0.5rem",
                          borderRadius: 5,
                          justifyContent: "center",
                          alignItems: "center",
                          borderColor: "#111",
                          borderWidth: 1,
                        }}
                      >
                        <FaArrowRight size={10} />
                      </TouchableOpacity>
                    </View>
                  </View>
                  {!isYoutubeUrl() ? (
                    <>
                      <View style={styles.middleControl}>
                        <Duration milliseconds={props.videoTime} />

                        <TouchableOpacity
                          onPress={() => {
                            props.SetVideoControl(!props.videoControl);
                          }}
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            backgroundColor: "rgba(232, 108, 0, 1)",
                            paddingHorizontal: "2rem",
                            paddingVertical: "1rem",
                            borderRadius: "8px",
                          }}
                        >
                          <View
                            style={{
                              width: "1rem",
                              height: "1rem",
                              borderRadius: "2rem",
                              justifyContent: "center",
                              alignItems: "center",
                              backgroundColor: "#fff",
                            }}
                          >
                            {!props.videoControl ? (
                              <FaPlay
                                color="rgba(232, 108, 0, 1)"
                                size={"0.5rem"}
                              />
                            ) : (
                              <FaPause
                                color="rgba(232, 108, 0, 1)"
                                size={"0.5rem"}
                              />
                            )}
                          </View>

                          <Text
                            style={{
                              fontsize: "18px",
                              color: "#fff",
                              fontWeight: "600",
                              marginStart: "0.6rem",
                            }}
                          >
                            {!props.videoControl ? "Play Video" : "Pause Video"}
                          </Text>
                        </TouchableOpacity>
                      </View>

                      <View style={styles.rightControl}>
                        <Text
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "10px",
                            fontWeight: "600",
                            color: "rgba(33, 33, 46, 0.5)",
                          }}
                        >
                          Playback Speed:
                        </Text>
                        <View
                          style={{
                            marginStart: "1rem",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <TouchableOpacity
                            onPress={() => {
                              setSpeed(0.25);
                            }}
                            style={{
                              width: "2.5rem",
                              height: "2.5rem",
                              borderRadius: 5,
                              justifyContent: "center",
                              alignItems: "center",
                              margin: 5,
                              border:
                                "0.715px solid rgba(144, 152, 161, 0.20) ",
                              backgroundColor:
                                speed === 0.25 && "rgba(232, 108, 0, 1)",
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "10px",
                                fontWeight: "600",
                                color:
                                  speed === 0.25
                                    ? "#fff"
                                    : "rgba(33, 33, 46, 0.50)",
                              }}
                            >
                              0.25x
                            </Text>
                          </TouchableOpacity>

                          <TouchableOpacity
                            onPress={() => {
                              setSpeed(0.5);
                            }}
                            style={{
                              width: "2.5rem",
                              height: "2.5rem",
                              borderRadius: 5,
                              justifyContent: "center",
                              alignItems: "center",
                              margin: 5,
                              border:
                                "0.715px solid rgba(144, 152, 161, 0.20) ",
                              backgroundColor:
                                speed === 0.5 && "rgba(232, 108, 0, 1)",
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "10px",
                                fontWeight: "600",
                                color:
                                  speed === 0.5
                                    ? "#fff"
                                    : "rgba(33, 33, 46, 0.50)",
                              }}
                            >
                              0.5x
                            </Text>
                          </TouchableOpacity>

                          <TouchableOpacity
                            onPress={() => {
                              setSpeed(0.75);
                            }}
                            style={{
                              width: "2.5rem",
                              height: "2.5rem",
                              borderRadius: 5,
                              justifyContent: "center",
                              alignItems: "center",
                              margin: 5,
                              border:
                                "0.715px solid rgba(144, 152, 161, 0.20) ",
                              backgroundColor:
                                speed === 0.75 && "rgba(232, 108, 0, 1)",
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "10px",
                                fontWeight: "600",
                                color:
                                  speed === 0.75
                                    ? "#fff"
                                    : "rgba(33, 33, 46, 0.50)",
                              }}
                            >
                              0.75x
                            </Text>
                          </TouchableOpacity>

                          <TouchableOpacity
                            onPress={() => {
                              setSpeed(1);
                            }}
                            style={{
                              width: "2.5rem",
                              height: "2.5rem",
                              borderRadius: 5,
                              justifyContent: "center",
                              alignItems: "center",
                              margin: 5,
                              border:
                                "0.715px solid rgba(144, 152, 161, 0.20) ",
                              backgroundColor:
                                speed === 1 && "rgba(232, 108, 0, 1)",
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "10px",
                                fontWeight: "600",
                                color:
                                  speed === 1
                                    ? "#fff"
                                    : "rgba(33, 33, 46, 0.50)",
                              }}
                            >
                              1x
                            </Text>
                          </TouchableOpacity>

                          <TouchableOpacity
                            onPress={() => {
                              setSpeed(1.25);
                            }}
                            style={{
                              width: "2.5rem",
                              height: "2.5rem",
                              borderRadius: 5,
                              justifyContent: "center",
                              alignItems: "center",
                              margin: 5,
                              border:
                                "0.715px solid rgba(144, 152, 161, 0.20) ",
                              backgroundColor:
                                speed === 1.25 && "rgba(232, 108, 0, 1)",
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "10px",
                                fontWeight: "600",
                                color:
                                  speed === 1.25
                                    ? "#fff"
                                    : "rgba(33, 33, 46, 0.50)",
                              }}
                            >
                              1.25x
                            </Text>
                          </TouchableOpacity>

                          <TouchableOpacity
                            onPress={() => {
                              setSpeed(1.5);
                            }}
                            style={{
                              width: "2.5rem",
                              height: "2.5rem",
                              borderRadius: 5,
                              justifyContent: "center",
                              alignItems: "center",
                              margin: 5,
                              border:
                                "0.715px solid rgba(144, 152, 161, 0.20) ",
                              backgroundColor:
                                speed === 1.5 && "rgba(232, 108, 0, 1)",
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "10px",
                                fontWeight: "600",
                                color:
                                  speed === 1.5
                                    ? "#fff"
                                    : "rgba(33, 33, 46, 0.50)",
                              }}
                            >
                              1.5x
                            </Text>
                          </TouchableOpacity>

                          <TouchableOpacity
                            onPress={() => {
                              setSpeed(1.75);
                            }}
                            style={{
                              width: "2.5rem",
                              height: "2.5rem",
                              borderRadius: 5,
                              justifyContent: "center",
                              alignItems: "center",
                              margin: 5,
                              border:
                                "0.715px solid rgba(144, 152, 161, 0.20) ",
                              backgroundColor:
                                speed === 1.75 && "rgba(232, 108, 0, 1)",
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "10px",
                                fontWeight: "600",
                                color:
                                  speed === 1.75
                                    ? "#fff"
                                    : "rgba(33, 33, 46, 0.50)",
                              }}
                            >
                              1.75x
                            </Text>
                          </TouchableOpacity>
                        </View>
                      </View>
                    </>
                  ) : null}
                </View>
              )}
            </View>
            <View
              style={{
                padding: 16,
                marginTop: "1rem",
                display: "flex",
                borderRadius: "0.2em",
                boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.22)",
                flexDirection: "row",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* Event Details */}
              <View
                style={{
                  borderRight: "1px #E5E7EB solid",
                  padding: 12,
                  marginBottom: 20,
                  elevation: 2,
                  width: "33%",
                }}
              >
                <Text
                  style={{ fontSize: 18, fontWeight: "600", marginBottom: 12 }}
                >
                  Event Details
                </Text>
                <InfoRow
                  label="QC Errors"
                  value={initialEventDetails?.error || 0}
                  bgColor="#fdecea"
                  textColor="#d32f2f"
                />
                <InfoRow
                  label="Review Errors"
                  value={initialEventDetails?.reviewError || 0}
                  bgColor="#fdecea"
                  textColor="#DA1414"
                />
                <InfoRow
                  label="Warnings"
                  value={initialEventDetails?.warning || 0}
                  bgColor="#fff4cc"
                  textColor="#f57c00"
                />
                <InfoRow
                  label="No Errors"
                  value={initialEventDetails?.noIssue || 0}
                  bgColor="#e6f4ea"
                  textColor="#2e7d32"
                />
                <InfoRow
                  label="Total events tag"
                  value={initialEventDetails.total || 0}
                  bgColor="#333"
                  textColor="#fff"
                  bold
                />
                <Text style={{ marginTop: 10, fontSize: 12, color: "#d32f2f" }}>
                  Warning: Submission of the analysis is only permitted once all
                  errors and warnings have been addressed.
                </Text>
              </View>

              {/* QC Status */}
              <View
                style={{
                  borderRight: "1px #E5E7EB solid",
                  padding: 12,
                  marginBottom: 20,
                  elevation: 2,
                  width: "33%",
                }}
              >
                <Text
                  style={{ fontSize: 18, fontWeight: "600", marginBottom: 12 }}
                >
                  QC Status
                </Text>
                <InfoRow
                  label="Active Errors"
                  value={errorCount || 0}
                  bgColor="#fdecea"
                  textColor="#d32f2f"
                />
                <InfoRow
                  label="Active Review Errors"
                  value={reviewErrorCount || 0}
                  bgColor="#fdecea"
                  textColor="#DA1414"
                />
                <InfoRow
                  label="Active Warnings"
                  value={warningCount || 0}
                  bgColor="#fff4cc"
                  textColor="#f57c00"
                />
                <InfoRow
                  label="No Errors"
                  value={noErrorsCount || 0}
                  bgColor="#e6f4ea"
                  textColor="#2e7d32"
                />
                <InfoRow
                  label="Issues Fixed"
                  value={
                    Math.max(
                      (initialEventDetails.warning || 0) +
                        (initialEventDetails.error || 0) +
                        (initialEventDetails.reviewError || 0) -
                        (errorCount + warningCount + reviewErrorCount),
                      0
                    ) || 0
                  }
                  bgColor="#e3f2fd"
                  textColor="#1976d2"
                />
                <InfoRow
                  label="Total events tag"
                  value={transformedStrings?.length || 0}
                  bgColor="#333"
                  textColor="#fff"
                  bold
                />
              </View>

              {/* Action Buttons */}
              <View
                style={{
                  padding: 12,
                  marginBottom: 20,
                  elevation: 2,
                  width: "33%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-around",
                  height: "-webkit-fill-available",
                }}
              >
                <div>
                  <TouchableOpacity
                    style={{
                      backgroundColor: "#F96302",
                      paddingVertical: 12,
                      borderRadius: 8,
                      alignItems: "center",
                      marginBottom: 12,
                      opacity:
                        transformedStrings?.length === undefined || isRunningQC
                          ? 0.6
                          : 1,
                      cursor:
                        transformedStrings?.length === undefined || isRunningQC
                          ? "not-allowed"
                          : "pointer",
                    }}
                    disabled={
                      transformedStrings?.length === undefined || isRunningQC
                    }
                    onPress={runTechQCManually}
                  >
                    <Text
                      style={{
                        color: "#fff",
                        fontWeight: "600",
                        fontSize: 16,
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      {isRunningQC ? (
                        <CircularProgress
                          size={20}
                          thickness={4}
                          color="secondary"
                        />
                      ) : (
                        <>
                          <FaSyncAlt style={{ marginRight: 6 }} /> Run Tech QC
                        </>
                      )}
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={{
                      backgroundColor:
                        errorCount > 0 ||
                        warningCount > 0 ||
                        reviewErrorCount > 0
                          ? "#A9A9A9"
                          : "#007D48",
                      paddingVertical: 12,
                      borderRadius: 8,
                      alignItems: "center",
                      opacity:
                        errorCount > 0 ||
                        warningCount > 0 ||
                        reviewErrorCount > 0 ||
                        transformedStrings?.length === undefined
                          ? 0.6
                          : 1,
                      cursor:
                        errorCount > 0 ||
                        warningCount > 0 ||
                        reviewErrorCount > 0 ||
                        transformedStrings?.length === undefined
                          ? "not-allowed"
                          : "pointer",
                    }}
                    disabled={
                      isSubmitting ||
                      errorCount > 0 ||
                      warningCount > 0 ||
                      reviewErrorCount > 0 ||
                      transformedStrings?.length === undefined
                    }
                    onPress={handleSubmitFinalQC}
                  >
                    <Text
                      style={{
                        color: "#fff",
                        fontWeight: "600",
                        fontSize: 16,
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      {isSubmitting ? (
                        <CircularProgress
                          sx={{
                            color: "#ffffff",
                          }}
                          size={20}
                          thickness={4}
                        />
                      ) : (
                        <>
                          Mark Analysis Done <FaArrowRight />
                        </>
                      )}
                    </Text>
                  </TouchableOpacity>
                </div>

                {errorCount > 0 ||
                warningCount > 0 ||
                reviewErrorCount > 0 ||
                transformedStrings?.length === undefined ? (
                  <Text
                    style={{ marginTop: 16, color: "#E02424", fontSize: 14 }}
                  >
                    Warning: Submission of the analysis is only permitted once
                    all errors, warnings, and review errors have been addressed.
                  </Text>
                ) : (
                  <Text
                    style={{ marginTop: 16, color: "#2e7d32", fontSize: 14 }}
                  >
                    ✓ All unresolved issues have been addressed. You may now
                    proceed with the submission.
                  </Text>
                )}
              </View>
            </View>
          </div>
        </div>
        <div
          style={{
            width: "40%",
            // height: "60rem",
            overflow: "hidden",
            borderRadius: 8,
            backgroundColor: "#fff",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "1rem 1rem 0rem 1rem",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <FilterButtons
                active={activeFilter}
                setActive={setActiveFilter}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                margin: "10px",
                alignItems: "center",
              }}
            >
              {/* Search Box */}
              <div
                style={{
                  flex: 1,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F3F4F6",
                  borderRadius: 6,
                  padding: "8px 12px",
                  border: "1px solid #E5E7EB",
                }}
              >
                <FaSearch color="#6B7280" size={14} />
                <input
                  value={searchStringValue}
                  onChange={(e) => setSearchStringValue(e.target.value)}
                  placeholder="Search String by Timestamp"
                  style={{
                    flex: 1,
                    marginLeft: 8,
                    border: "none",
                    outline: "none",
                    backgroundColor: "transparent",
                    fontSize: 16,
                    color: "#111827",
                  }}
                />
                {searchStringValue && searchMatchIndexes.length > 0 && (
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: 12,
                        paddingRight: "6px",
                        borderRight: "1px solid #6B7280",
                        color: "#555",
                      }}
                    >
                      {searchMatchIndexes.indexOf(currentSearchIndex) + 1} /{" "}
                      {searchMatchIndexes.length}
                    </Typography>

                    <FaAngleUp
                      onClick={goToNextSearchMatch}
                      style={{
                        cursor: "pointer",
                      }}
                      color="#6B7280"
                      size={16}
                    />

                    <FaAngleDown
                      style={{
                        cursor: "pointer",
                      }}
                      color="#6B7280"
                      size={16}
                      onClick={goToPrevSearchMatch}
                    />
                    <FaTimes
                      size={16}
                      color="#6B7280"
                      style={{ cursor: "pointer" }}
                      onClick={() => setSearchStringValue("")}
                    />
                  </Stack>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  width: "100%",
                  gap: 10,
                }}
              >
                {/* Prev Error Button */}
                <button
                  disabled={Boolean(searchStringValue.length)}
                  onClick={goToPrevError}
                  style={{
                    cursor: Boolean(searchStringValue.length)
                      ? "not-allowed"
                      : "pointer",
                    opacity: Boolean(searchStringValue.length) ? 0.6 : 1,
                    padding: "8px 14px",
                    borderRadius: 6,
                    backgroundColor: "#E5E7EB",
                    border: "1px solid #D1D5DB",
                    fontWeight: 600,
                    color: "#374151",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    width: "100%",
                    justifyContent: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <FaArrowLeft /> Prev Error
                </button>

                {/* Next Error Button */}
                <button
                 disabled={Boolean(searchStringValue.length)}
                  onClick={goToNextError}
                  style={{
                    padding: "8px 12px",
                      cursor: Boolean(searchStringValue.length)
                      ? "not-allowed"
                      : "pointer",
                    opacity: Boolean(searchStringValue.length) ? 0.6 : 1,
                    borderRadius: 6,
                    backgroundColor: "#FF5A1F",
                    color: "white",
                    width: "100%",
                    justifyContent: "center",
                    border: "none",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    whiteSpace: "nowrap",
                  }}
                >
                  Next Error <FaArrowRight />
                </button>

                <LegendTooltipIcon />
              </div>
            </div>
          </div>
          {transformedStrings && transformedStrings.length > 0 ? (
            <div style={{ height: "86%" }}>
              {filteredData.length > 0 ? (
                <AutoSizer>
                  {({ width, height }) => {
                    return (
                      <List
                        ref={listRef}
                        scrollToAlignment="start"
                        style={{
                          padding: "10px",
                          marginTop: "0.6rem",
                          paddingBottom: "2rem",
                        }}
                        onScroll={({ scrollTop }) => {
                          setScrollPosition(scrollTop);
                        }}
                        width={width}
                        height={height}
                        deferredMeasurementCache={cache.current}
                        rowCount={filteredData.length}
                        scrollToIndex={
                          searchStringValue && currentSearchIndex !== -1
                            ? currentSearchIndex
                            : currentErrorGlobalIndex != null &&
                              !skipScrollToIndex
                            ? currentErrorGlobalIndex
                            : undefined
                        }
                        rowHeight={cache.current.rowHeight}
                        rowRenderer={({ index, key, style, parent }) => {
                          const item = filteredData[index];
                          return (
                            <CellMeasurer
                              key={key}
                              cache={cache.current}
                              parent={parent}
                              columnIndex={0}
                              rowIndex={index}
                            >
                              <div style={style}>
                                <EditableTag
                                  key={item.id}
                                  activeFilter={activeFilter}
                                  index={index}
                                  refetch={refetchReviewerStrings}
                                  analystId={analystId}
                                  searchValue={searchStringValue}
                                  token={token}
                                  matchId={matchId}
                                  errorIndex={currentErrorGlobalIndex}
                                  reviewerId={reviewerId}
                                  text={item.value}
                                  type={item.type}
                                  message={item.message}
                                  ignored={item.ignored}
                                  reviewStatus={item.reviewStatus}
                                  reviewComments={item.reviewComments}
                                  onChange={(newVal) => {
                                    // cache.current.clear(index);
                                    updateTag(item.id, newVal);
                                  }}
                                  onAddNewtag={() => {
                                    // cache.current.clearAll();
                                    addTag(item.id);
                                  }}
                                  onDelete={() => {
                                    // cache.current.clearAll();
                                    deleteStringByIndex(item.id);
                                  }}
                                  jumpManually={jumpManually}
                                />
                              </div>
                            </CellMeasurer>
                          );
                        }}
                      />
                    );
                  }}
                </AutoSizer>
              ) : (
                <Stack
                  style={{
                    padding: 16,
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <Typography style={{ color: "gray", fontSize: 16 }}>
                    {`No ${activeFilter} strings found`}
                  </Typography>
                </Stack>
              )}
            </div>
          ) : IsInitialQC ? (
            <Stack
              style={{
                flex: 1,
                padding: 16,
                alignItems: "center",
                justifyContent: "center",
                height: "60vh",
              }}
            >
              <Stack style={{ alignItems: "center" }}>
                <CircularProgress
                  sx={{
                    color: "#F96302",
                  }}
                />
                <Typography
                  style={{ color: "gray", fontSize: 16, marginTop: 12 }}
                >
                  Loading QC Data
                </Typography>
              </Stack>
            </Stack>
          ) : (
            <Stack
              style={{
                padding: 16,
                alignItems: "center",
                justifyContent: "center",
                maxHeight: "-webkit-fill-available",
                height: "60vh",
              }}
            >
              <Typography style={{ color: "gray", fontSize: 16 }}>
                No strings available
              </Typography>
            </Stack>
          )}
        </div>
      </div>
    </div>
  );
};

const InfoRow = ({ label, value, bgColor, textColor, bold }) => (
  <View
    style={{
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginVertical: 6,
      paddingBottom: 8,
      borderBottom: "1px #E5E7EB solid",
    }}
  >
    <Text
      style={{ fontSize: 16, color: "#333", fontWeight: bold ? "700" : "400" }}
    >
      {label}
    </Text>
    <View
      style={{
        backgroundColor: bgColor,
        paddingHorizontal: 10,
        paddingVertical: 4,
        borderRadius: 6,
        minWidth: 40,
        alignItems: "center",
      }}
    >
      <Text style={{ color: textColor, fontWeight: "600" }}>{value}</Text>
    </View>
  </View>
);

const EditableTag = ({
  text,
  activeFilter,
  ignored,
  onChange,
  errorIndex,
  index,
  refetch,
  message,
  onAddNewtag,
  onDelete,
  type = "noIssue",
  analystId,
  jumpManually,
  token,
  matchId,
  searchValue,
  reviewerId,
  reviewStatus,
  reviewComments,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(text);

  const highlightText = (text, search) => {
    if (!search) return text;

    const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escaped})`, "ig");

    return text.split(regex).map((part, i) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <span
          key={i}
          style={{
            backgroundColor: "#FFE58F",
            padding: "0 2px",
            borderRadius: 3,
            fontWeight: 600,
          }}
        >
          {part}
        </span>
      ) : (
        <span key={i}>{part}</span>
      )
    );
  };

  const getEventFromString = (str) => {
    const parts = str?.split("-");
    if (parts?.length < 3) return null;
    const eventCode = `${parts?.[2]}-${parts?.[3]}`;
    return EVENT_MAP[eventCode] || null;
  };

  useEffect(() => {
    setValue(text);
  }, [text]);

  const handleIgnoredStrings = async () => {
    try {
      await saveReviewerFeedback({
        token,
        body: {
          match_id: Number(matchId),
          reviewer_id: reviewerId ?? analystId,
          string_details: [
            {
              string: value,
              string_status: 3,
              comments: message || "",
            },
          ],
        },
      });

      toast.success("Marked as Ignored");

      // Update UI immediately
      onChange({
        value,
        type: "ignored",
        message,
        ignored: true,
        reviewStatus: 3, // ⭐ store ignored status
        reviewComments: message,
      });
    } catch (err) {
      console.error("Failed to ignore string:", err);
      toast.error("Failed to mark as ignored");
    }
  };

  const handleMarkedAsFixed = async () => {
    try {
      // remove old value update wih new
      await saveReviewerFeedback({
        token,
        body: {
          match_id: Number(matchId),
          reviewer_id: reviewerId ?? analystId,
          string_details: [
            // {
            //   string: value,
            //   string_status: reviewStatus,
            //   comments: reviewComments,
            //   delete: true,
            // },
            {
              string: value,
              string_status: 1,
              comments: reviewComments,
            },
          ],
        },
      });
      await refetch();
      toast.success("Marked as fixed");

      //update ui
      onChange({
        value,
        type: "fixed",
        message: "Issue resolved",
        ignored: false,
        reviewStatus: 1,
        reviewComments,
      });
    } catch (err) {
      console.error("Failed to fix review error:", err);
      toast.error("Failed to mark as fixed");
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
    onChange({
      value,
      type,
      message,
      ignored,
      reviewStatus,
      reviewComments,
    });
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 0:
        return { text: "Pending", color: "#f57c00", bgColor: "#fff4cc" };
      case 1:
        return { text: "Approved", color: "#2e7d32", bgColor: "#e6f4ea" };
      case 2:
        return { text: "Rejected", color: "#d32f2f", bgColor: "#fdecea" };
      default:
        return { text: "N/A", color: "#666", bgColor: "#f5f5f5" };
    }
  };

  const getStyleByType = (type, stringValue) => {
    const eventData = getEventFromString(stringValue);
    switch (type) {
      case "error":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: eventData.bgColor,
            textColor: "#000000",
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#DA1414",
          backgroundColor: "#FEEFEF",
          textColor: "#DA1414",
          iconColor: "#DA1414",
          badgeColor: "#f6e3e3ff",
          status: "Error",
        };
      case "review_error":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: eventData.bgColor,
            textColor: "#000000",
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#DA1414",
          backgroundColor: "#FEEFEF",
          textColor: "#DA1414",
          iconColor: "#DA1414",
          badgeColor: "#f6e3e3ff",
          status: "Review Error",
        };
      case "warning":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: eventData.bgColor,
            textColor: "#000000",
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#B95000",
          backgroundColor: "#FFF4EC",
          textColor: "#B95000",
          badgeColor: "#f7e9ddff",
          iconColor: "#B95000",
          status: "Warning",
        };
      case "fixed":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: eventData.bgColor,
            textColor: "#000000",
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaCheckCircle,
          badgeColor: "#bad9faff",
          status: "Fixed",
          borderColor: "#1A56DB",
          backgroundColor: "#E1EFFE",
          textColor: "#000000",
          iconColor: "#1A56DB",
        };

      case "ignored":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: eventData.bgColor,
            textColor: "#000000",
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaCheckCircle,
          borderColor: "#287D3C",
          backgroundColor: "#EDF9F0",
          textColor: "#287D3C",
          iconColor: "#287D3C",
          badgeColor: "#d9f2ddff",
          status: "Ignored",
        };
      case "noIssue":
      default:
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: eventData.bgColor,
            textColor: "#000000",
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaCheckCircle,
          borderColor: "#287D3C",
          backgroundColor: "#EDF9F0",
          textColor: "#287D3C",
          badgeColor: "#d9f2ddff",
          iconColor: "#287D3C",
          status: "No issue",
        };
    }
  };

  const {
    borderColor,
    statusIcon,
    backgroundColor,
    badgeColor,
    textColor,
    iconColor,
    status,
  } = getStyleByType(type, value);

  const reduceTimeBySeconds = (timeString, secondsToReduce) => {
    const [hh, mm, rest] = timeString.split(":");
    const [ss, ms = "0"] = rest.split(".");

    const hours = parseInt(hh, 10);
    const minutes = parseInt(mm, 10);
    const seconds = parseInt(ss, 10);
    const milliseconds = parseInt(ms.padEnd(3, "0"), 10);

    let totalMs = (hours * 3600 + minutes * 60 + seconds) * 1000 + milliseconds;
    totalMs -= secondsToReduce * 1000;

    if (totalMs < 0) totalMs = 0;

    const newHours = Math.floor(totalMs / 3600000);
    const newMinutes = Math.floor((totalMs % 3600000) / 60000);
    const newSeconds = Math.floor((totalMs % 60000) / 1000);
    const newMs = totalMs % 1000;

    return `${newHours.toString().padStart(2, "0")}:${newMinutes
      .toString()
      .padStart(2, "0")}:${newSeconds.toString().padStart(2, "0")}.${newMs
      .toString()
      .padStart(3, "0")}`;
  };

  const jumpManuallyViaString = () => {
    const timeStr = value.split("-")[6];
    const newTimeStr = reduceTimeBySeconds(timeStr, 2);
    jumpManually(newTimeStr);
  };

  const statusInfo = getStatusLabel(reviewStatus);

  return (
    <Stack>
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "5px",
          alignItems: "baseline",
          width: "100%",
          marginBottom: "5px",
          justifyContent: "center",
        }}
      >
        <Stack
          sx={{
            backgroundColor,
            borderRadius: "8px",
            paddingX: "12px",
            paddingY: "10px",
            border: `1px solid ${borderColor}`,
            borderWidth: "1px",
            borderColor,
            marginBottom: "1px",
            minHeight: "30px",
            width: "90%",
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <TouchableOpacity activeOpacity={1} style={{ flex: 1 }}>
            {isEditing ? (
              <TextInput
                autoFocus
                value={value}
                onChangeText={setValue}
                onBlur={handleBlur}
                style={{
                  fontSize: 14,
                  color: "black",
                  backgroundColor: "#fff",
                  accentColor: "white",
                  outline: "none",
                  padding: 3,
                }}
              />
            ) : (
              <Typography
                style={{
                  fontSize: 14,
                  color: textColor,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "1rem",
                }}
              >
                {React.createElement(statusIcon, { color: iconColor })}
                <span>{highlightText(value, searchValue)}</span>
              </Typography>
            )}
          </TouchableOpacity>

          <Stack
            style={{ flexDirection: "row", alignItems: "center", gap: 10 }}
          >
            {isEditing && (
              <TouchableOpacity
                onPress={handleBlur}
                style={{
                  marginLeft: "1rem",
                }}
              >
                <FaCheck color={iconColor} />
              </TouchableOpacity>
            )}
            <TouchableOpacity onPress={jumpManuallyViaString}>
              <FaVideo color={iconColor} />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => setIsEditing(true)}>
              <FaEdit color={iconColor} />
            </TouchableOpacity>
            <TouchableOpacity onPress={onDelete}>
              <FaTrashAlt color="#DA1414" />
            </TouchableOpacity>

            {type === "warning" ? (
              <TouchableOpacity
                style={{
                  paddingHorizontal: 8,
                  paddingVertical: 4,
                  borderRadius: 4,
                  borderWidth: 1,
                  borderColor: iconColor,
                  marginLeft: 6,
                }}
                onPress={handleIgnoredStrings}
              >
                <Typography style={{ color: iconColor, fontSize: 12 }}>
                  Mark as Ignored
                </Typography>
              </TouchableOpacity>
            ) : type === "review_error" ? (
              <TouchableOpacity
                style={{
                  paddingHorizontal: 8,
                  paddingVertical: 4,
                  borderRadius: 4,
                  borderWidth: 1,
                  backgroundColor: badgeColor,
                  borderColor: borderColor,
                  marginLeft: 6,
                }}
                onPress={handleMarkedAsFixed}
              >
                <Typography style={{ color: textColor, fontSize: 12 }}>
                  Mark as Fixed
                </Typography>
              </TouchableOpacity>
            ) : (
              <Typography
                style={{
                  color: iconColor,
                  borderRadius: "5px",
                  marginLeft: 8,
                  backgroundColor: badgeColor,
                  padding: "0.2rem",
                  fontSize: 12,
                }}
              >
                {status}
              </Typography>
            )}
          </Stack>
        </Stack>
        {activeFilter === "all" && (
          <TouchableOpacity
            style={{
              color: "white",
              backgroundColor: "#FF5A1F",
              borderRadius: "8px",
              padding: "12px",
            }}
            onPress={() => onAddNewtag(index)}
          >
            <FaPlus />
          </TouchableOpacity>
        )}
      </Stack>
      <Stack
        style={{
          ...(activeFilter !== "all" && {
            display: "flex",
            alignItems: "center",
          }),
        }}
      >
        {type === "warning" ? (
          <Typography
            style={{
              borderColor: "#B95000",
              backgroundColor: "#FFF4EC",
              color: "#B95000",
              padding: "6px",
              width: "90%",
              marginBottom: 4,
              borderRadius: "8px",
              fontSize: 12,
            }}
          >
            Warning! {message}
          </Typography>
        ) : type === "error" ? (
          <Typography
            style={{
              padding: "6px",
              borderColor: "#DA1414",
              backgroundColor: "#FEEFEF",
              color: "#DA1414",
              width: "90%",
              marginBottom: 4,
              fontSize: 12,
              borderRadius: "8px",
            }}
          >
            Error! {message}
          </Typography>
        ) : type === "review_error" ? (
          <Typography
            style={{
              padding: "6px",
              borderColor: "#DA1414",
              backgroundColor: "#fdecea",
              color: "#DA1414",
              width: "90%",
              marginBottom: 4,
              fontSize: 12,
              borderRadius: "8px",
            }}
          >
            Review Error! {message}
          </Typography>
        ) : null}
      </Stack>
    </Stack>
  );
};

const FilterButtons = ({ active, setActive }) => {
  const filters = [
    { label: "All", value: "all" },
    { label: "Errors", value: "error" },
    { label: "Review Errors", value: "review_error" },
    { label: "Warnings", value: "warning" },
    { label: "Ignored", value: "ignored" },
  ];

  return (
    <View style={{ flexDirection: "row", gap: 8, marginTop: 8 }}>
      {filters.map(({ label, value }) => {
        const isActive = active === value;

        return (
          <TouchableOpacity
            key={value}
            onPress={() => setActive(value)}
            style={{
              backgroundColor: isActive ? "#FF5A1F" : "#E5E7EB",
              borderRadius: 10,
              minWidth: "95px",
              paddingHorizontal: 20,
              height: "40px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              style={{
                color: isActive ? "#fff" : "#000",
                fontSize: 14,
                fontWeight: "500",
              }}
            >
              {label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const LegendTooltipIcon = () => {
  const grouped = {
    passing: [],
    shooting: [],
    defending: [],
    goalkeeping: [],
  };

  Object.entries(EVENT_MAP).forEach(([key, val]) => {
    grouped[val.group].push({ code: key, ...val });
  });

  return (
    <Tooltip
      arrow
      placement="left"
      title={
        <Box
          sx={{
            maxHeight: 260,
            overflowY: "auto",
            p: 1,
          }}
        >
          {/* PASSING */}
          <GroupLabel title="Passing (Green tones)" />
          {grouped.passing.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* SHOOTING */}
          <GroupLabel title="Shooting (Red / Orange tones)" mt />

          {grouped.shooting.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* DEFENDING */}
          <GroupLabel title="Defending (Blue tones)" mt />

          {grouped.defending.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* GK */}
          <GroupLabel title="Goalkeeping (Purple / Amber)" mt />

          {grouped.goalkeeping.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}
        </Box>
      }
      componentsProps={{
        tooltip: {
          sx: {
            background: "#1F1F1F",
            borderRadius: "8px",
            maxWidth: 260,
            p: 1,
          },
        },
      }}
    >
      <IconButton size="small">
        <InfoOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

const GroupLabel = ({ title, mt }) => (
  <Typography
    fontWeight={700}
    fontSize={12}
    sx={{ mt: mt ? 1 : 0.2, mb: 0.5, opacity: 0.9 }}
  >
    {title}
  </Typography>
);

const LegendRow = ({ item }) => (
  <Stack direction="row" alignItems="center" spacing={1} mb={0.4}>
    {/* Color box */}
    <Box
      sx={{
        width: 12,
        height: 12,
        borderRadius: "3px",
        background: item.color,
      }}
    />

    <Typography sx={{ width: 48, fontSize: 12, fontWeight: 600 }}>
      {item.code}
    </Typography>

    <Typography sx={{ fontSize: 12, opacity: 0.8 }}>{item.label}</Typography>
  </Stack>
);

const styles = {
  header: {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: 60,
      backgroundColor: "#fff",
      padding: "0 16px",
      boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
      zIndex: 10,
    },
    side: {
      width: 60,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    center: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 8,
    },
    score: {
      color: "#1C64F2",
      fontWeight: "bold",
      fontSize: 16,
    },
    matchInfo: {
      color: "#667085",
      fontSize: 14,
    },
    logout: {
      color: "#FF5A1F",
      cursor: "pointer",
      fontWeight: "500",
    },
  },

  cardContainer: {
    display: "flex",
    gap: 10,
    padding: 20,
  },

  card1: {
    card: {
      flex: 1,
      height: 80,
      borderRadius: 8,
      backgroundColor: "#fff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      display: "flex",
      width: "90%",
      justifyContent: "space-around",
    },
    team: {
      display: "flex",
      flexDirection: "column",
      gap: 12,
      width: "50%",
    },
    teamNameText: {
      fontWeight: "bold",
      fontSize: 14,
      textAlign: "center",
      marginBottom: 4,
    },
    teamBoxA: {
      backgroundColor: "#E7F5EC",
      padding: "4px 16px",
      borderRadius: 4,
      alignItems: "flex-start",
    },
    teamBoxB: {
      backgroundColor: "#E5F5FC",
      padding: "4px 16px",
      borderRadius: 4,
      alignItems: "flex-end",
    },
    label: {
      fontWeight: 400,
      textAlign: "center",
      fontSize: 14,
    },
  },

  card2: {
    card: {
      flex: 1,
      height: 80,
      borderRadius: 8,
      backgroundColor: "#fff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      width: "90%",
      display: "flex",
      alignItems: "center",
      gap: 20,
    },
    box: {
      backgroundColor: "rgba(12, 157, 65, 0.1)",
      padding: "16px 10px",
      borderRadius: 8,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    id: {
      fontWeight: 500,
      fontSize: 18,
      color: "#000",
    },
    textRight: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
    },
    name: {
      fontWeight: 600,
      color: "#000",
      fontSize: 16,
    },
    label: {
      fontSize: 13,
      color: "#394452",
    },
  },

  card3: {
    card: {
      flex: 1,
      height: 80,
      borderRadius: 8,
      backgroundColor: "#fff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "90%",
      gap: 20,
    },
    title: {
      fontWeight: 600,
      color: "#000",
      fontSize: 18,
    },
    time: {
      color: "#FF5A1F",
      fontWeight: 500,
      fontSize: 16,
    },
    progressBar: {
      width: 60,
    },
    timeProgressWrapper: {
      display: "flex",
      alignItems: "center",
      gap: 20,
    },
  },

  urlCard: {
    wrapper: {
      padding: 10,
      borderRadius: 12,
      backgroundColor: "#fff",
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      margin: "0 20px",
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 20,
    },
    label: {
      fontWeight: 500,
      fontSize: 16,
      whiteSpace: "nowrap",
    },
    inputGroup: {
      display: "flex",
      border: "1px solid #E0E0E0",
      borderRadius: 8,
      overflow: "hidden",
      width: "30%",
    },
    input: {
      flex: 1,
      padding: "10px 12px",
      border: "none",
      outline: "none",
      fontSize: 14,
    },
    button: {
      backgroundColor: "#FF5A1F",
      border: "none",
      padding: "0 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
  },

  container: {
    flex: 1,
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    backgroundColor: "#fff",
    marginBottom: "1rem",
  },
  videoContainer: {
    width: "100%",
    flex: "0.70",
    paddingHorizontal: "1rem",
    borderRadius: "0.2em",
    boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.22)",
  },

  videoTimeline: {
    paddingTop: 5,
    paddingBottom: 5,
    width: "100%",
    paddingHorizontal: "1rem",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItem: "center",
  },

  controlContainer: {
    width: "96%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "rgba(238, 242, 250, 1)",
    alignSelf: "center",
    paddingHorizontal: "0.8rem",
    paddingVertical: "1rem",
  },
  leftControl: {
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    gap: "2px",
  },
  middleControl: {
    alignItems: "center",
  },
  rightControl: {
    flexDirection: "row",
    alignItems: "center",
  },
};

const mapStateToProps = (state) => {
  return {
    videoControl: state.control.videoControl,
    videoUrl: state.control.videoUrl,
    videoTime: state.control.videoTime,
    all_matches: state.match.all_matches,
    currentAction: state.control.currentAction,
    analysedString: state.control.analysedString,
    actionLog: state.control.actionLog,
    seekToTime: state.control.seekToTime,
    analystId: state.auth.analyst_id,
  };
};

export default connect(mapStateToProps, {
  UpdateVideoTime,
  LoadVideoUrl,
  SetVideoControl,
  SetControllerToggle,
  ClearSeekFlag,
})(TechQCMS);
